import React, { PureComponent, Fragment } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { isURL } from 'validator';
import { bool } from 'prop-types';
import { offers } from '../../services/ApiService';
import Card from '../Card/Card';
import AlertModal from '../../modals/AlertModal/AlertModal';
import { ThemedFMessage } from '../../hoc/IntlComponents';

class LandingRequest extends PureComponent {
  static propTypes = {
    loading: bool,
  };

  state = {
    loading: false,
    modal: false,
    type: 'landing',
    url: '',
    message: '',
  };

  changeType = type => {
    this.setState(() => ({ type }));
  };

  handleChange = ({ target }) => {
    this.setState(() => ({ [target.name]: target.value }));
  };

  handleSubmit = e => {
    e.preventDefault();
    const { offerId } = this.props;
    const { url, type } = this.state;
    const request = { url: url.trim(), type, offerId };

    this.setState(() => ({ loading: true }));

    offers
      .sendLandingRequest(request)
      .then(({ items = [] }) => items[0])
      .then((result = {}) => result.message)
      .then(message => {
        if (message) {
          this.setState(() => ({
            loading: false,
            modal: true,
            message,
          }));
        }
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.error) {
          const { message: error } = response.data.error;

          this.setState(() => ({
            loading: false,
            modal: true,
            message: error.message,
          }));
        }
      });
  };

  onModalClose = () => {
    this.setState(() => ({ url: '', modal: false, message: '' }));
  };

  render() {
    const { loading, type, url, modal, message } = this.state;
    const { theme } = this.props;
    return (
      <Fragment>
        <Card loading={loading} className="landing-request card-extended card-loading-silent">
          <Card.Header>
            <div className="card-title">
              <FormattedMessage id="landing-request.title" defaultMessage="Addition" />
            </div>

            <div className="card-controls themed-card-controls">
              <ul className="nav nav-pills">
                <li className="nav-item">
                  <button
                    type="button"
                    className={cn('nav-link', { active: type === 'landing' })}
                    onClick={() => this.changeType('landing')}
                  >
                    <FormattedMessage
                      id="landing-request.type.landing"
                      defaultMessage="Landing Page"
                    />
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={cn('nav-link', { active: type === 'prelander' })}
                    onClick={() => this.changeType('prelander')}
                  >
                    <ThemedFMessage id='landing-request.type.prelander' />
                  </button>
                </li>
              </ul>
            </div>
          </Card.Header>
          <Card.Body>
            <p className="no-margin">
              {type === 'landing' ? (
                <FormattedMessage
                  id="landing-request.text.landing"
                  defaultMessage="Not enough landings? Let's add quickly!"
                />
              ) : (
                  <ThemedFMessage
                    id="landing-request.text.prelander"
                  />
                )}
            </p>
          </Card.Body>

          <Card.Footer>
            <form className="landing-request-form" onSubmit={this.handleSubmit} autoComplete="off">
              <input
                type="url"
                name="url"
                className="landing-request-field"
                value={url}
                onChange={this.handleChange}
                placeholder="http://example.com"
                aria-label="Enter URL"
                readOnly={loading}
              />

              <Button
                type="submit"
                color="primary"
                size="sm"
                disabled={!isURL(url, { require_protocol: true }) || loading}
              >
                <FormattedMessage
                  id="landing-request.request"
                  defaultMessage="Request an Addition"
                />
              </Button>
            </form>
          </Card.Footer>
        </Card>

        <AlertModal open={modal} message={message} onClose={this.onModalClose} />
      </Fragment>
    );
  }
}

export default LandingRequest;
